/* TODO: remove this file, we use the driver from jdesktop repo */
import gpio from "gpio";

const CLOCK_PIN = 27;
const PULSE_PIN = 22;
const BOUNCE_TIME = 30;

export default class {
	constructor() {
	}
	start() {
		return new Promise(function(resolve, reject) {
			if (!gpio.pin[CLOCK_PIN].exported())
				gpio.pin[CLOCK_PIN].export();

			if (!gpio.pin[PULSE_PIN].exported())
				gpio.pin[PULSE_PIN].export();

			setTimeout(function() {
				gpio.pin[CLOCK_PIN].direction = 1;
				gpio.pin[PULSE_PIN].direction = 0;
				gpio.pin[CLOCK_PIN].onclear = this.__onchange_handler.bind(this);
				resolve(true);
			}.bind(this), 1000);
		}.bind(this));
	}
	stop() {
	}
	__onchange_handler() {
		var value = gpio.pin[PULSE_PIN].value;
		gpio.pin[PULSE_PIN].value = 0;
		gpio.pin[PULSE_PIN].direction = 1;
		//console.log(gpio.pin[PULSE_PIN].value);
		if (gpio.pin[PULSE_PIN].value == 0) {
			if (typeof this.onpoweroff=="function")
				this.onpoweroff();
			console.warn("Power loss. System going down for system halt NOW!");
			var subProcess = new SubProcess();
			subProcess.call("sudo poweroff");
		}

		gpio.pin[PULSE_PIN].direction = 0;
		gpio.pin[PULSE_PIN].value = !value;
	}
	get battery_type() {
		return {
			0x46: "LiFePO4 (ASCII : F)",
			0x51: "LiFePO4 (ASCII : Q)",
			0x53: "LiPO (ASCII: S)",
			0x50: "LiPO (ASCII: P)",
			0x43: "LiPO (ASCII: P)"
		}[gpio.i2c[1].readByteData(0x6b, 0x07)];
	}
	get power_mode() {
		var data = gpio.i2c[1].readByteData(0x69, 0x00);
		data = data & ~(1 << 7)
		return {
			1: "Cable",
			2: "Battery"
		}[data]
	}
	get firmware_version() {
		return gpio.i2c[1].readByteData(0x69, 0x26);
	}
	get boot_version() {
		return gpio.i2c[1].readByteData(0x69, 0x25);
	}
	get pcb_version() {
		return gpio.i2c[1].readByteData(0x69, 0x24);
	}
	get battery_voltage() {
		var str = gpio.i2c[1].readWordData(0x69, 0x08).toString(16);
		return (parseFloat(str) / 100)
	}
	get battery_percentage() {
		var datavolts = this.battery_voltage;
		var databattery = this.battery_type;
		var datapercentage;

		if ((databattery == "LiFePO4 (ASCII : F)") || (databattery == "LiFePO4 (ASCII : Q)")) {
			var databatminus = datavolts-2.90
			datapercentage = ((databatminus/0.70))*100
		} else if ((databattery == "LiPO (ASCII: S)") || (databattery == "LiPO (ASCII: P)")) {
			var databatminus = datavolts-3.4
			datapercentage = ((databatminus/0.899))*100
		}
		return datapercentage;
	}
};